import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {
    ArchiveOrUnarchiveConfirmationModalInfo: {
      showModal: false,
      record: {}
    }
  };
}

const state = initialState();

const getters = {
  ArchiveOrUnarchiveConfirmationModalInfo(state) {
    return state.ArchiveOrUnarchiveConfirmationModalInfo;
  }
};

const actions = {
  openArchiveOrUnarchiveConfirmationModal(context, data) {
    context.commit("openArchiveOrUnarchiveConfirmationModal", data);
  },
  closeAssignCallLoggingModal: function(context) {
    context.commit("closeArchiveOrUnarchiveConfirmationModal");
  },
  updateArchiveStatus: function(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/dashboard/hide_or_show_call", request)
        .then(resp => {
          if (resp.status == 200) resolve();
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};

const mutations = {
  openArchiveOrUnarchiveConfirmationModal: function(state, data) {
    state.ArchiveOrUnarchiveConfirmationModalInfo.showModal = true;
    state.ArchiveOrUnarchiveConfirmationModalInfo.record = data;
  },
  closeArchiveOrUnarchiveConfirmationModal: function(state) {
    state.ArchiveOrUnarchiveConfirmationModalInfo.showModal = false;
    state.ArchiveOrUnarchiveConfirmationModalInfo.record = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ArchiveOrUnarchive.js